import {Injectable} from "@angular/core";
import {isNullOrUndefined} from "util";
import {AbstractControl, FormGroup, NgModel} from "@angular/forms";

@Injectable()
export class InputModifierService {
    public transformControlValue<T>(controlSource: AbstractControl | ControlAccessor,
                                    domEvent: any,
                                    transformer: (value: T) => T): void {
        let control = (controlSource instanceof AbstractControl ? controlSource : controlSource.getControl());
        if (!control) {
            return;
        }
        let originalValue = control.value;
        if (isNullOrUndefined(originalValue)) {
            return;
        }
        let transformedValue = transformer(originalValue);
        if (originalValue == transformedValue) {
            return;
        }
        if (!isNullOrUndefined(transformedValue) && domEvent.target == document.activeElement) {
            this.updateControlPreservingCaretPosition(control, domEvent.target, originalValue, transformedValue);
        } else {
            control.patchValue(transformedValue);
        }
    }

    private updateControlPreservingCaretPosition(control: AbstractControl, nativeElement: any, originalValue: any, transformedValue: any) {
        let start = nativeElement.selectionStart;
        let end = nativeElement.selectionEnd;
        let originalLength = originalValue.length;
        let modifiedLength = transformedValue.length;
        control.patchValue(transformedValue);
        let newEnd = end - Math.abs(modifiedLength - originalLength);
        nativeElement.setSelectionRange(start, newEnd);
    }
}

export interface ControlAccessor {

    getControl(): AbstractControl;

}

export class ControlAccessors {
    public static forReactiveForm(formGroup: FormGroup, controlName: string): ControlAccessor {
        return {
            getControl(): AbstractControl {
                return formGroup.controls[controlName];
            }
        };
    }

    public static forTemplateDrivenForm(model: NgModel): ControlAccessor {
        return {
            getControl(): AbstractControl {
                return model.control;
            }
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/input-modifier.service.ts